import { render, staticRenderFns } from "./Riskpoint.vue?vue&type=template&id=1e432f74&scoped=true&"
import script from "./Riskpoint.vue?vue&type=script&lang=js&"
export * from "./Riskpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e432f74",
  null
  
)

export default component.exports